import * as Sentry from '@sentry/react';
import { get } from 'lodash';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

Sentry.init({
    dsn: 'https://000414df68c76e7afe48475faebf5dbb@o4505585101701120.ingest.us.sentry.io/4508531567689728',
    enabled: import.meta.env.MODE !== 'development',
    environment: import.meta.env.MODE,
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            createRoutesFromChildren,
            matchRoutes,
            useEffect,
            useLocation,
            useNavigationType,
        }),
        Sentry.replayIntegration({
            blockAllMedia: false,
            maskAllInputs: false,
            maskAllText: false,
        }),
    ],
    normalizeDepth: 10,
    release: `dashboard@${__VERSION__}`,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    tracesSampleRate: 1.0,
    beforeSend: (event) => {
        for (const exception of get(event, 'exception.values', [])) {
            for (const frame of get(exception, 'stacktrace.frames', [])) {
                // 忽略来自扩展的错误
                if (frame?.filename?.includes('chrome-extension://') || frame?.filename?.includes('moz-extension://')) {
                    return null;
                }
            }
        }

        return event;
    },
});
